import { Button, Field, Input, Modal } from "@dd/ui";
import { useEffect, useState } from "react";
import { api } from "../lib/api.ts";
import { getUser } from "../lib/auth.ts";

export function StepUpDialog() {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");
  const [recovery, setRecovery] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const mfa = Boolean(getUser()?.twoFactorEnabled);
  useEffect(() => {
    const show = () => {
      setOpen(true);
      setError(null);
    };
    window.addEventListener("dd:step-up-required", show);
    return () => window.removeEventListener("dd:step-up-required", show);
  }, []);
  async function verify() {
    setBusy(true);
    setError(null);
    try {
      await api.security.stepUp(
        mfa ? { code: value, recovery } : { password: value },
      );
      setOpen(false);
      setValue("");
      window.dispatchEvent(new CustomEvent("dd:step-up-complete"));
    } catch (cause) {
      setError(
        cause instanceof Error ? cause.message : "No pudimos verificarte.",
      );
    } finally {
      setBusy(false);
    }
  }
  return (
    <Modal
      open={open}
      title="Confirmá que sos vos"
      description="Esta acción accede o modifica información sensible. La autorización dura unos minutos."
      onClose={() => !busy && setOpen(false)}
    >
      <div className="space-y-4">
        <Field
          label={
            mfa
              ? recovery
                ? "Código de recuperación"
                : "Código del autenticador"
              : "Contraseña actual"
          }
          htmlFor="step-up-value"
        >
          <Input
            id="step-up-value"
            type={mfa && !recovery ? "text" : mfa ? "text" : "password"}
            inputMode={mfa && !recovery ? "numeric" : "text"}
            autoComplete={mfa ? "one-time-code" : "current-password"}
            autoFocus
            value={value}
            onChange={(event) => setValue(event.target.value)}
          />
        </Field>
        {mfa && (
          <button
            type="button"
            className="text-xs font-medium text-primary hover:underline"
            onClick={() => {
              setRecovery((current) => !current);
              setValue("");
            }}
          >
            {recovery ? "Usar autenticador" : "Usar código de recuperación"}
          </button>
        )}
        {error && (
          <p role="alert" className="text-sm text-danger">
            {error}
          </p>
        )}
        <Button
          className="w-full"
          disabled={busy || value.length < 1}
          onClick={verify}
        >
          {busy ? "Verificando…" : "Continuar"}
        </Button>
        <p className="text-xs text-muted-foreground">
          Después de verificarte, repetí la acción que estabas realizando.
        </p>
      </div>
    </Modal>
  );
}
